import React from 'react';
import { Protect, SignedOut, SignedIn } from '@clerk/clerk-react';

export const ClerkSignedOut = SignedOut as React.FC<{ children: React.ReactNode }>;
export const ClerkSignedIn = SignedIn as React.FC<{ children: React.ReactNode }>;
export const ClerkProtect = Protect as React.FC<{
  children: React.ReactNode;
  role?: string;
  fallback?: React.ReactNode;
  condition?: (has: HasFunction) => boolean;
}>;

type HasFunction = (condition: {
  role?: string;
  permission?: string;
  feature?: string;
  plan?: string;
}) => boolean;

type Props = {
  children: React.ReactNode;
  role?: string;
  fallback?: React.ReactNode;
  condition?: (has: HasFunction) => boolean;
};

export const ProtectWrapper = ({ children, role, fallback, condition }: Props): JSX.Element => {
  return (
    <ClerkProtect condition={condition} fallback={fallback} role={role}>
      {children}
    </ClerkProtect>
  );
};
